export const getWellListPinOptions = (useStateLabel) => [
  { key: 'assemblyType', label: 'Assembly Type', external: true, options: ['Rotary', 'Motor', 'RSS'] },
  { key: 'rig', label: 'Rig' },
  { key: 'county', label: 'County' },
  { key: 'district', label: 'District' },
  { key: 'operator', label: 'Operator' },
  { key: 'organization', label: 'Organization' },
  { key: 'wellStatus', label: 'Well Status' },
  { key: 'state', label: useStateLabel ? 'State' : 'Country' },
  { key: 'phase', label: 'Phase' },
  { key: 'formation', label: 'Formation' },
]

export const logisticsPinOptions = [
  { key: 'rig', label: 'Rig' },
  { key: 'operator', label: 'Operator' },
  { key: 'toolType', label: 'Tool Type' },
  { key: 'make', label: 'Make' },
  { key: 'model', label: 'Model' },
  { key: 'organization', label: 'Organization' },
  { key: 'wellStatus', label: 'Well Status' },
  { key: 'county', label: 'County' },
  { key: 'state', label: 'State' },
  { key: 'toolStatus', label: 'Tool Status' },
]
